import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "p-mt-3" }, [
  /*#__PURE__*/_createTextVNode(" If the JSON response contains the data in simple list of objects format like: "),
  /*#__PURE__*/_createVNode("pre", null, "  {\n    \"contextResponses\": [\n      {\n        \"a\":3,\n        \"c\":\"d\",\n        \"e\":\"f\"\n      },{\n        \"a\":2,\n        \"e\":\"r\",\n        \"f\":\"s\",\n        \"b\":\"q\"\n       }\n     ]\n  }\n      "),
  /*#__PURE__*/_createTextVNode(" then it will be sufficient to define only the JSON Path Items and check "),
  /*#__PURE__*/_createVNode("b", null, "Use directly JSON Attributes"),
  /*#__PURE__*/_createTextVNode(" without defining the attributes. The attributes will be retrieved automatically from the JSON Objects: the names will be the fields names, the values will be the fields values. In this examples, the JSON Path Items will be: "),
  /*#__PURE__*/_createVNode("pre", null, "  $.contextResponses[*]\n      "),
  /*#__PURE__*/_createTextVNode(" and the result DataSet content will have these objects (name: value): "),
  /*#__PURE__*/_createVNode("pre", null, "  \"a\":3\n  \"c\":\"d\"\n  \"e\":\"f\"\n  ...\n      ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.$t('managers.datasetManagement.helpTitle'),
    style: _ctx.detailDescriptor.style.infoDialog,
    visible: _ctx.visible,
    modal: true,
    class: "p-fluid kn-dialog--toolbar--primary",
    closable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["header", "style", "visible"]))
}